<template>
  <div>
    <vue-table ref="vueTable" :table-data="tableData">
      <template slot="searchBar">
        <el-form-item label="时间范围">
          <date-range-picker :start.sync="tableData.search.start_at" :end.sync="tableData.search.end_at" width="240px" type="before"/>
        </el-form-item>
        <el-form-item label="操作内容">
          <el-input v-model.trim="tableData.search.content" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="username" slot-scope="{row}">
        <span>{{row.username}}</span>
        <span v-if="row.admin && row.admin.name">({{row.admin.name}})</span>
      </template>
      <template slot="location" slot-scope="{row}">{{formatLocation(row)}}</template>
    </vue-table>
  </div>
</template>

<script>
import DateRangePicker from "@view/components/date/DateRangePicker.vue"
export default {
  name: "log",
  components: {DateRangePicker},
  data() {
    return {
      tableData: {
        tableList: [],
        tableColumn: [
          { label: "操作时间", property: "create_at", width: 150},
          { label: "操作IP", property: "ip", width: 120},
          { label: "操作位置", property: "location", width: 130},
          { label: "操作账号", property: "username", width: 150},
          { label: "浏览器信息", property: "user_agent", tooltip: true, width: 150},
          { label: "操作内容", property: "content", minWidth: 200},
        ],
        search: {
          start_at: "",
          end_at: "",
          content: "",
        },
        api: "getActionLog"
      },
    }
  },
}
</script>

<style scoped>

</style>
